import { computed, observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import { getOmniData } from '@src/services/omni-api';
import $$tracker from '@src/tracker';
import { useEffect } from 'react';

let swiperRef = null;
let swiperTabRef = null;
class ClanStore {
  @observable config = {};
  @observable isActive = false;
  @observable currentKey = 0;
  @observable showSlides = false;
  @observable showSwiper = true;
  @observable swiperList = {};
  clanKeys = {
    易水: 'yishui',
    武当: 'wudang',
    烬宗: 'jinzong',
    天王: 'tianwang',
    千机: 'qianji'
  };

  @computed
  get paramsTabs() {
    const that = this;
    return {
      loop: true,
      slidesPerView: 5,
      // spaceBetween: 48,
      centeredSlides: true,
      watchSlidesVisibility: true, //防止不可点击
      on: {
        init: function() {
          swiperTabRef = this;
          that.showSlides = true;
        },
        slideChange: function() {
          that.currentKey = this.realIndex;
          const key = Object.keys(that.swiperList)[this.realIndex % Object.keys(that.swiperList).length];
          $$tracker.clickMenpai(that.swiperList[key].name);
        },
        click: function() {
          const visibleSlidesIndexes = this.visibleSlidesIndexes;
          const clickedIndex = this.clickedIndex;
          const foundIndex = visibleSlidesIndexes.findIndex(index => index === clickedIndex);
          if (foundIndex > -1) {
            if (foundIndex < 2) {
              this.slidePrev();
            } else if (foundIndex > 2) {
              this.slideNext();
            }
          }
        }
      }
    };
  }
  @computed
  get params() {
    const that = this;
    return {
      loop: true,
      effect: 'fade',
      on: {
        init: function() {
          swiperRef = this;
        },
        thumbs: {
          swiper: swiperTabRef
        }
        // slideChange: function() {
        //   that.currentKey = this.realIndex;
        //   const key = Object.keys(that.swiperList)[that.currentKey];
        //   // $$tracker.clickMenpai(that.swiperList[key].name);
        // }
      }
    };
  }

  changeSwiper = currentKey => {
    if (currentKey === 'prev') {
      swiperTabRef?.slidePrev();
    } else if (currentKey === 'next') {
      swiperTabRef?.slideNext();
    }
    // if (this.currentKey === currentKey) {
    //   return;
    // }
    // swiperRef?.slideToLoop(currentKey);
    // this.currentKey = currentKey;
    // $$tracker.clickMenpai(this.swiperList[currentKey].name);
  };

  getData = async () => {
    try {
      const res = await getOmniData('channel_cat_8e881bee', [
        {
          dataSourceId: 'ds_cat_7d735a58',
          page: 1,
          perPage: 10
        }
      ]);
      // console.log('门派', res);
      // 处理门派数据
      const clanData = res.ds_cat_7d735a58?.result?.items || [];
      const swiperList = {};
      // 合并数据
      Object.keys(this.clanKeys).forEach((key, index) => {
        const clan = this.clanKeys[key];
        const clanInfo = clanData.find(item => item.title === key);
        if (clanInfo) {
          const clanConfig = {
            id: index + 1,
            name: key,
            tab: clanInfo.carousel_icon_unselected?.[0]?.url || '',
            tabActive: clanInfo.carousel_icon_selected?.[0]?.url || '',
            bg: clanInfo.bg_img?.[0]?.url || clanData[0]?.bg_img?.[0]?.url || '',
            bg_video: clanInfo.bg_video?.[0]?.url || '',
            color: clanInfo.color?.[0]?.url || '',
            role: clanInfo.character_illustration?.[0]?.url || '',
            title: clanInfo.title_img?.[0]?.url || '',
            foreground: clanInfo.fore_ground?.[0]?.url || '',
            weapon: clanInfo.weapon_illustration?.[0]?.url || '',
            verse: clanInfo.name_intro_image?.[0]?.url || '',
            leida: clanInfo.stats_radar_chart?.[0]?.url || ''
          };
          swiperList[clan] = clanConfig;
        }
      });
      this.swiperList = swiperList;
    } catch (error) {
      console.log(error);
    }
  };

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  use() {
    useMount(() => {
      this.getData();
    });

    useEffect(() => {
      // 监听视口变化，节流200ms，变更showSwiper=false,随后为true
      let timer = null;
      const handleResize = () => {
        timer && clearTimeout(timer);
        this.showSwiper = false;
        timer = setTimeout(() => {
          this.showSwiper = true;
          clearTimeout(timer);
        }, 500);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  }
}
export default ClanStore;
